import { render, staticRenderFns } from "./RoteirizacaoCustoPanel.vue?vue&type=template&id=fb8d74da&scoped=true&"
import script from "./RoteirizacaoCustoPanel.vue?vue&type=script&lang=js&"
export * from "./RoteirizacaoCustoPanel.vue?vue&type=script&lang=js&"
import style0 from "./RoteirizacaoCustoPanel.vue?vue&type=style&index=0&id=fb8d74da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8d74da",
  null
  
)

export default component.exports